import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  selectLoginModal,
  setShowForgotPassword,
  setShowWelcomeModal,
} from "../../features/modals/modalsSlice";
import {
  logout,
  selectLogged,
  setUserLoginDetails,
} from "../../features/user/userSlice";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { PRIMARY, SECONDARY } from "../../const/colors";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { errorNotification } from "../../utils/toastNotifications";
import { API_URL } from "../../const/api";
import axios from "axios";
import { useCookies } from "react-cookie";
import {
  ButtonLogin,
  Container,
  ForgotPassword,
  Form,
  InputItem,
} from "./LoginElements";
import InfoIcon from "@mui/icons-material/Info";
import { useEffect } from "react";
import OlvidoClave from "../../components/olvidoClave";
import { Helmet } from "react-helmet";
import { clearLimites } from "../../features/limitaciones/limitacionesSlice";

const initialForm = {
  user: "",
  password: "",
};

const LoginPage = ({ setHideNav }) => {
  const [form, setForm] = useState(initialForm);
  const [error, setError] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const isLoggedIn = useSelector(selectLogged);
  const loginModal = useSelector(selectLoginModal);
  const [t] = useTranslation("global");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [cookies, setCookie] = useCookies(["user"]);

  useEffect(() => {
    setHideNav(true);
    return () => {
      setHideNav(false);
    };
  }, []);

  const validateForm = () => {
    if (!form.user || !form.password) {
      setError({
        user: !form.user ? t("login.enter-user") : "",
        password: !form.password ? t("login.enter-password") : "",
      });
      return false;
    } else {
      setError(initialForm);
      return true;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);

      try {
        const res = await axios.post(API_URL + "auth", form);
        if (res.data.status === 1) {
          dispatch(setUserLoginDetails(res.data));

          if (res.data.estado !== "1") {
            //usuario bloqueado
            dispatch(logout({}));
            dispatch(clearLimites({}));
            //navigate('/');
            Swal.fire({
              title: `"${res.data.user}": ${t("alert.errorNotificationRetiro-72")}`,
              text: t("alert.errorNotificationRetiro-71"),
              allowOutsideClick: false,
              icon: "error",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonText: "OK",
              confirmButtonColor: PRIMARY,
            }).then((result) => {
              if (result.isConfirmed) {
                setForm(initialForm);
                window.location.href = "/";
              }
            });
          } else {
            let now = new Date();
            let minutes = 90;
            now.setTime(now.getTime() + minutes * 60 * 1000);
            const enc = await axios.post(API_URL + "guardar", {
              a: form.user,
              b: form.password,
            });
            if (enc.data) {
              setCookie("MBA", enc.data.aenc, { path: "/", expires: now });
              setCookie("MBB", enc.data.benc, { path: "/", expires: now });
            }
            if (res.data.change_passwd === "1") {
              navigate("/cambiarPassword");
            } else {
              if (res.data.change_passwd === "2") {
                navigate("/completarDatos");
              } else {
                handleLogin(res.data.user);
              }
            }
          }
          setLoading(false);
        } else {
          errorNotification(t("alert.errorNotificationRetiro-49"));
          setLoading(false);
        }
      } catch (error) {
        //console.log(error)
        errorNotification(t("alert.errorNotificationRetiro-6"));
        setLoading(false);
      }
    }
  };

  const handleLogin = (nombre) => {
    const swalInstance = Swal.fire({
      title: `${t("login.welcome")} ${nombre}!`,
      text: t("login.login-succes"),
      icon: "success",
      background: SECONDARY,
      color: "#fff",
      confirmButtonColor: PRIMARY,
      allowOutsideClick: false, // Evita que se cierre haciendo clic fuera
    });

    swalInstance.then((result) => {
      if (result.isConfirmed) {
        window.location.reload(); // Recarga la página si se confirmó el diálogo
      }
    });

    dispatch(setShowWelcomeModal(true));
    navigate(t("header.link-1.url"));
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
    validateForm();
  };

  const olvidoClave = () => {
    dispatch(setShowForgotPassword(true));
  };

  return !isLoggedIn ? (
    <>
      <Helmet>
        <link rel="canonical" href="https://masterbets365.com/LogIn" />
      </Helmet>
      <Container>
        <Form autoComplete="off">
          <h3>{t("login.log-in")}</h3>
          <div>
            <InputItem value={form.user}>
              <input
                type="text"
                required
                name="user"
                value={form.user}
                onChange={handleChange}
                className={error.user ? "error" : null}
              />
              <label>{t("login.username")}</label>
              {error.user && (
                <p className="error">
                  <InfoIcon /> {error.user}
                </p>
              )}
            </InputItem>
            <InputItem value={form.password}>
              <input
                type="password"
                required
                name="password"
                value={form.password}
                onChange={handleChange}
                className={error.password ? "error" : null}
              />
              <label>{t("login.password")}</label>
              {error.password && (
                <p className="error">
                  <InfoIcon /> {error.password}
                </p>
              )}
            </InputItem>
            <ButtonLogin
              type="submit"
              disabled={loading}
              onClick={handleSubmit}
            >
              {loading ? "CARGANDO..." : t("login.log-in")}
            </ButtonLogin>
            <ForgotPassword onClick={olvidoClave}>
              {t("login.forgot-password")}
            </ForgotPassword>
          </div>
        </Form>
        <OlvidoClave />
      </Container>
    </>
  ) : (
    <Navigate to="/" />
  );
};

export default LoginPage;
